import React from 'react';
import { Cross } from '@saleshandy/icons';
import Button from '../../../../../../shared/design-system/components/atoms/button';
import { McpLogo } from '../mcp-tool-logos';

type Props = {
  onDismiss: () => void;
};

const McpInfoBanner: React.FC<Props> = ({ onDismiss }) => (
  <section className="mcp-info-banner">
    <Button className="mcp-info-banner__close" onClick={onDismiss}>
      <Cross width={16} height={16} />
    </Button>

    <div className="mcp-info-banner__header">
      <div className="mcp-info-banner__icon">
        <McpLogo />
      </div>
      <div>
        <h3 className="mcp-info-banner__title">What is MCP?</h3>
        <p className="mcp-info-banner__desc">
          MCP (Model Context Protocol) lets AI assistants like Claude, ChatGPT,
          and Cursor directly interact with Saleshandy. Instead of clicking
          through menus, you simply tell the AI what you want in plain English.
        </p>
      </div>
    </div>

    <div className="mcp-info-banner__comparison">
      <div className="mcp-info-banner__comparison-card">
        <span className="mcp-info-banner__comparison-label mcp-info-banner__comparison-label--without">
          WITHOUT MCP
        </span>
        <p className="mcp-info-banner__comparison-text">
          Navigate to Sequences → Click Create → Fill form → Add steps →
          Configure settings → Save
        </p>
      </div>
      <div className="mcp-info-banner__comparison-card">
        <span className="mcp-info-banner__comparison-label mcp-info-banner__comparison-label--with">
          WITH MCP
        </span>
        <div className="mcp-info-banner__comparison-prompt">
          <p className="mcp-info-banner__comparison-prompt-text">
            "Create a 5-step follow-up sequence for demo no-shows"
          </p>
        </div>
      </div>
    </div>
  </section>
);

export default McpInfoBanner;
